import "../../App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "components/core/Route/PrivateRoute";
import Login from "components/core/Login/Login";
import HomePage from "components/core/HomePage/HomePage";
import PoDetails from "components/core/PO/PoDetails/PoDetailsView";
import GrnListView from "components/core/GRN/GrnListView";
import GrnDetailsView from "components/core/GRN/GrnDetailsView";
import Invoice from "components/core/GRN/Invoice";
import CreditNote from "components/core/GRN/CreditNote";
import Tnc from "components/core/Login/Tnc";
import AllDDPoView from "components/core/PO/DirectDelivery/AllDDPoView";
import DDPoDetails from "components/core/PO/DirectDelivery/DDPoDetails";
import DDPoInvoiceForm from "components/core/PO/DirectDelivery/DDPoInvoiceForm";
import ToastContainer from "sushiweb/ToastContainer";
import DDPodForm from "components/core/PO/DirectDelivery/DDPodForm";
import DDPodFormV2 from "components/core/PO/DirectDelivery/DDPodFormV2";
import BOView from "components/core/PO/DirectDelivery/BOView";
import ReuploadInvoice from "components/core/PO/ReuploadInvoice";
import ServicePoView from "components/core/PO/ServicePurchaseOrder/ServicePoView";
import AllServicePOsView from "components/core/PO/ServicePurchaseOrder/AllServicePOsView";
import Profile from "components/core/Profile/Profile";
import DeleteAccount from "components/core/DeleteAccount/DeleteAccount";
import DeleteAccountOtp from "components/core/DeleteAccount/DeleteAccountOtp";
import PlanShipmentRouter from "components/core/PlanShipment/PlanShipmentRouter";
import PayoutView from "components/core/Payouts/PayoutView";
import PaymentDetails from "components/core/Payouts/PaymentDetails";
import UploadDocuments from "components/core/PO/UploadDocuments";
import GenerateEwb from "components/core/PO/GenerateEwb";
import UploadSupportingDocs from "components/core/PO/UploadSupportingDocs";
import DownloadLabels from "components/core/EmbeddedUpc/DownloadLabels";
import PackagingCompliance from "components/core/EmbeddedUpc/PackagingCompliance";
import DownloadPackagingLabel from "components/core/EmbeddedUpc/DownloadPackagingLabel";
import PackagingLabelsTnc from "components/core/EmbeddedUpc/PackagingLabelsTnc";
import TrackPageLoad from "components/core/Route/TrackPageLoad";
import TrackClick from "components/core/Route/TrackClick";
import BidsFilterPage from "components/core/Bids/BidsList/BidsFilterPage";
import BidsListView from "components/core/Bids/BidsList/BidsListView";
import BidDetails from "components/core/Bids/BidDetails/BidDetails";
import BidsFAQ from "components/core/Bids/BidsFAQ";
import BidConfirmation from "components/core/Bids/BidDetails/BidConfirmation";
import OnboardingForm from "components/core/Onboarding/OnboardingForm";
import PaymentsPlaceholder from "components/core/Onboarding/PaymentsPlaceholder";
import ManageUsers from "components/core/ManageUsers/ManageUsers";
import AddUser from "components/core/ManageUsers/AddUser";
import AddUserSuccess from "components/core/ManageUsers/AddUserSuccess";
import RaiseDisputePage from "components/core/GRN/RaiseDisputePage";
import VerifyEmailOtpPage from "components/core/GRN/VerifyEmailOtpPage";
import PurchaseOrderListView from "components/core/PO/PurchaseOrderList/PurchaseOrderListView";
import PublicMarkEntry from "components/core/PlanShipment/PublicMarkEntry";
import PublicMarkEntryQr from "components/core/PlanShipment/PublicMarkEntryQr";

function SellerApp() {
  return (
    <ToastContainer>
      <div className="App">
        <Router>
          <TrackPageLoad />
          <TrackClick />
          <Routes>
            <Route
              path={"/"}
              element={
                <PrivateRoute>
                  <HomePage />
                </PrivateRoute>
              }
            />
            <Route path={"login"} element={<Login />} />
            <Route path={"onboarding/form"} element={<OnboardingForm />} />
            <Route path={"payments"} element={<PaymentsPlaceholder />} />
            <Route path={"plan-shipment/markentry"} element={<PublicMarkEntry />} />
            <Route path={"plan-shipment/markentry/qr"} element={<PublicMarkEntryQr />} />
            <Route path={"po/pending"} element={<Navigate to="/po/list" replace />} />
            <Route
              path={"/tnc/:status"}
              element={
                <PrivateRoute>
                  <Tnc />
                </PrivateRoute>
              }
            />
            <Route
              path={"po/details/:source/:purchaseOrderId"}
              element={
                <PrivateRoute>
                  <PoDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/details/:source/:purchaseOrderId"}
              element={
                <PrivateRoute>
                  <DDPoDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/invoice/:purchaseOrderId"}
              element={
                <PrivateRoute>
                  <DDPoInvoiceForm />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/pod/:purchaseOrderId/:orderId/:goTo"}
              element={
                <PrivateRoute>
                  <DDPodForm />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/pod/v2/:purchaseOrderId/:orderId"}
              element={
                <PrivateRoute>
                  <DDPodFormV2 />
                </PrivateRoute>
              }
            />
            <Route
              path={"grn/list"}
              element={
                <PrivateRoute>
                  <GrnListView />
                </PrivateRoute>
              }
            />
            <Route
              path={"grn/details/:source/:purchaseOrderId/:grnId"}
              element={
                <PrivateRoute>
                  <GrnDetailsView />
                </PrivateRoute>
              }
            />
            <Route
              path={"grn/invoice/:source/:purchaseOrderId/:grnId"}
              element={
                <PrivateRoute>
                  <Invoice />
                </PrivateRoute>
              }
            />
            <Route
              path={"grn/creditNote/:grnId"}
              element={
                <PrivateRoute>
                  <CreditNote />
                </PrivateRoute>
              }
            />
            <Route path={"po/all"} element={<Navigate to="/po/list" replace />} />
            <Route
              path={"po/list"}
              element={
                <PrivateRoute>
                  <PurchaseOrderListView />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/all"}
              element={
                <PrivateRoute>
                  <AllDDPoView />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/:purchaseOrderId/buyer_orders"}
              element={
                <PrivateRoute>
                  <BOView />
                </PrivateRoute>
              }
            />
            <Route
              path={"po/service/:type"}
              element={
                <PrivateRoute>
                  <ServicePoView />
                </PrivateRoute>
              }
            />
            <Route
              path={"po/service/all"}
              element={
                <PrivateRoute>
                  <AllServicePOsView />
                </PrivateRoute>
              }
            />
            <Route
              path={"upload-documents/:purchaseOrderNumber"}
              element={
                <PrivateRoute>
                  <UploadDocuments />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/generateEwb/:purchaseOrderId"}
              element={
                <PrivateRoute>
                  <GenerateEwb />
                </PrivateRoute>
              }
            />
            <Route
              path={"ddPo/uploadDocs/:purchaseOrderId"}
              element={
                <PrivateRoute>
                  <UploadSupportingDocs />
                </PrivateRoute>
              }
            />
            <Route
              path={"grn-document-update/:grnNumber/:referenceNumber"}
              element={
                <PrivateRoute>
                  <ReuploadInvoice />
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/all"}
              element={
                <PrivateRoute>
                  <BidsFilterPage />
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/faq"}
              element={
                <PrivateRoute>
                  <BidsFAQ />
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/confirm"}
              element={
                <PrivateRoute>
                  <BidConfirmation />
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/details/:bidId"}
              element={
                <PrivateRoute>
                  <BidDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/list/:status"}
              element={
                <PrivateRoute>
                  <BidsListView />
                </PrivateRoute>
              }
            />
            <Route
              path={"bids/:status"}
              element={
                <PrivateRoute>
                  <BidsListView />
                </PrivateRoute>
              }
            />
            <Route
              path={"profile"}
              element={
                <PrivateRoute>
                  <Profile />
                </PrivateRoute>
              }
            />
            <Route
              path={"manage-users"}
              element={
                <PrivateRoute>
                  <ManageUsers />
                </PrivateRoute>
              }
            />
            <Route
              path={"manage-users/add"}
              element={
                <PrivateRoute>
                  <AddUser />
                </PrivateRoute>
              }
            />
            <Route
              path={"manage-users/add/success"}
              element={
                <PrivateRoute>
                  <AddUserSuccess />
                </PrivateRoute>
              }
            />
            <Route
              path={"delete-account"}
              element={
                <PrivateRoute>
                  <DeleteAccount />
                </PrivateRoute>
              }
            />
            <Route
              path={"download-labels"}
              element={
                <PrivateRoute>
                  <DownloadLabels />
                </PrivateRoute>
              }
            />
            <Route
              path={"download-labels/compliance"}
              element={
                <PrivateRoute>
                  <PackagingCompliance />
                </PrivateRoute>
              }
            />
            <Route
              path={"download-labels/download"}
              element={
                <PrivateRoute>
                  <DownloadPackagingLabel />
                </PrivateRoute>
              }
            />
            <Route
              path={"download-labels/tnc"}
              element={
                <PrivateRoute>
                  <PackagingLabelsTnc />
                </PrivateRoute>
              }
            />
            <Route
              path={"delete-account/verify"}
              element={
                <PrivateRoute>
                  <DeleteAccountOtp />
                </PrivateRoute>
              }
            />
            <Route
              path={"plan-shipment/*"}
              element={
                <PrivateRoute>
                  <PlanShipmentRouter />
                </PrivateRoute>
              }
            />
            <Route
              path={"payouts"}
              element={
                <PrivateRoute>
                  <PayoutView />
                </PrivateRoute>
              }
            />
            <Route
              path={"payouts/details"}
              element={
                <PrivateRoute>
                  <PaymentDetails />
                </PrivateRoute>
              }
            />
            <Route
              path={"grn/dispute/:source/:purchaseOrderId/:grnId"}
              element={
                <PrivateRoute>
                  <RaiseDisputePage />
                </PrivateRoute>
              }
            />
            <Route
              path={"user/verify-email"}
              element={
                <PrivateRoute>
                  <VerifyEmailOtpPage />
                </PrivateRoute>
              }
            />
          </Routes>
        </Router>
      </div>
    </ToastContainer>
  );
}

export default SellerApp;
